class MmmAppDriver {
    constructor() { }

    addFab() {
        var appLink = 'https://medscape.onelink.me/U6kk/74ncg05j';
        if (breakpoint === 1) {
            appLink = 'https://medscape.onelink.me/U6kk/vpczv4ir';
        }

        var fabHtml = `<div class="fab-icon" onclick="wmdPageLink(\'fltgactnbttn_open\', this);"></div>
        <div class="fab-modal">
            <div class="close-layer" onclick="wmdPageLink(\'fltgactnbttn_close\', this);"></div>
            <div class="fab-cta">
                <div class="promo-img">
                    <span>Get the Free Medscape App</span>
                </div>
                <div class="qr-codes">
                    <a class="qr-app-store" href="${appLink}" onclick="wmdPageLink(\'fltgactnbttn_applestr\', this);"
                        target="_blank">
                        <span class="qr"></span>
                        <span class="dl">Download on the App Store</span>
                    </a>
                    <a class="qr-google-play" href="${appLink}" onclick="wmdPageLink(\'fltgactnbttn_googlestr\', this);"
                        target="_blank">
                        <span class="qr"></span>
                        <span class="dl">Get it on Google Play</span>
                    </a>
                </div>
                <div class="send-msg-body">
                    <div class="send-msg-content">
                        <div class="send-msg-header-text">Or, send yourself a link to download the app later.</div>
                        <div class="send-msg-input">
                            <label>Email</label>
                            <input type="text" class="input-field send-msg-email-recipient" placeholder="email@mail.com"
                                value="${PageMetadata.addProfile.email.trim()}">
                        </div>
                        <div class="send-msg-error">Please use a valid email address</div>
                        <div class="send-msg-footer">
                            <button type="submit" class="send-msg-button">Send Email</button>
                            <div class="send-msg-noshow-text">
                                <a id="noshow" href="javascript:void(0);"
                                    onclick="wmdPageLink(\'fltgactnbttn_disppr\', this);">Don&#39;t
                                    show me this again</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="send-msg-loading">
                    <div class="spinner"></div>
                </div>
                <div class="send-msg-success">
                    <p class="success-msg">Your email has been sent</p>
                    <p><a href="javascript:void(0);">Resend Email</a></p>
                </div>
            </div>
            <div class="fab-driver">
                <p class="driver-benefits">Unlimited Access &amp; Benefits in Your Pocket:</p>
                <p class="driver-offline">Offline access to the Medscape drug database</p>
                <p class="driver-navigation">Easy navigation of drug information</p>
                <p class="driver-drugs">Interaction Checker, Pill Identifier, and more clinical tools</p>
            </div>
        </div>
        <div class="layer-blackout"></div>
        </div>`;

        var modalDiv = document.createElement('div');
        modalDiv.classList.add('fab');
        modalDiv.innerHTML = fabHtml;
        document.getElementById('bodypadding').appendChild(modalDiv);
        this.showFabIcon();
        this.addEvents();
    }

    addEvents() {
        const fabIcon = document.querySelector('.fab-icon');
        fabIcon.addEventListener('click', () => {
            this.showFab();
        });
        const fabClose = document.querySelector('.fab-modal .close-layer');
        fabClose.addEventListener('click', () => {
            this.hideFab();
        });
        const noshow = document.querySelector('.send-msg-noshow-text #noshow');
        noshow.addEventListener('click', () => {
            this.hideFabIconPerpetually();
        });
        const sentMsg = document.querySelector('.send-msg-footer .send-msg-button');
        sentMsg.addEventListener('click', (e) => {
            this.validateFabEmail(e);
        });
        const successMsg = document.querySelector('.fab-modal .send-msg-success');
        successMsg.addEventListener('click', (e) => {
            this.resetFab();
        });
    }
    
    showFab() {
        document.body.classList.add('show-fab-modal');
    }

    hideFab() {
        document.body.classList.remove('show-fab-modal');
    }

    showFabIcon() {
        document.body.classList.add('show-fab-icon');
    }

    hideFabIcon() {
        document.body.classList.remove('show-fab-icon');
    }

    resetFab() {
        document.querySelector('.fab').classList.remove('error');
        document.querySelector('.fab').classList.remove('success');
    }

    validateFabEmail(elem) {
        document.querySelector('.fab').classList.remove('error');
        document.querySelector('.fab .send-msg-email-recipient').value = document.querySelector('.fab .send-msg-email-recipient').value.trim();
        var recipEmail = document.querySelector('.fab .send-msg-email-recipient').value;
        var mailTestPattern = /^[a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]([a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]||([.]{1,1}[a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]))*@([A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9]\.)+[A-Za-z]{2,6}$/;

        if (recipEmail.length == 0) {
            document.querySelector('.fab .send-msg-error').innerHTML = 'Please enter a recipient email address';
            document.querySelector('.fab').classList.add('error');
        } else if (mailTestPattern.test(recipEmail) == false || recipEmail.match(/@/g).length > 1 || recipEmail.match(/[ "(),:;<>\[\\\]]/g) !== null) {
            document.querySelector('.fab .send-msg-error').innerHTML = 'Please use a valid email address';
            document.querySelector('.fab').classList.add('error');
        } else {
            document.querySelector('.fab').classList.add('loading');
            wmdPageLink('fltgactnbttn_sndeml', elem);
            this.sendFabEmail();
        }
    }

    sendFabEmail() {
        $.ajax({
            url: 'https://www.' + getDomain() + 'medscape.com/api/v1/notificationservice/ese/email',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                "appId": "FABEmail",
                "emailTo": document.querySelector('.fab .send-msg-email-recipient').value,
                "subject": "Get the Free Medscape App",
                "fileShare": `Medscape_App_Download_Trigger_HTML.html`
            }),
            type: 'POST',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            success: (json) => {
                document.querySelector('.fab').classList.remove('loading');
                document.querySelector('.fab').classList.add('success');
                this.hideFabIconPerpetually(true);
            }
        });
    }

    hideFabIconPerpetually(emailFlag) {
        var exDate = new Date();
        exDate.setTime(exDate.getTime() + (30 * 24 * 60 * 60 * 1000));
        document.cookie = 'clsfab=true; path=/; domain=medscape.com; expires=' + exDate.toGMTString();
        this.hideFabIcon();
        if (typeof emailFlag == 'undefined') {
            this.hideFab();
        }
    }

}

export {
    MmmAppDriver
}